import { v4 as uuidv4 } from "uuid";

export const generateFileKey = (fileType: string) => {
  return `${uuidv4()}.${fileType.split("/").pop()}`;
};
